<template>
  <form v-if="tagsHaveBeenPreloaded">
    <div class="dashboard-page-title">
      <div class="container-fluid">
        <h1>What you are known for</h1>

        <a @click="$router.go(-1)" class="btn btn-info" active-class="">
          <i class="fa fa-chevron-left"></i> Back
        </a>
      </div>
    </div>

    <div class="container-fluid">
      <div class="dashboard-block">
        <div class="row">
          <div class="col-md-10 col-lg-8">
            <div class="panel panel-grey">
              <div class="panel-body">
                  <div v-if="!$isNflClub">
                    <h3>{{ $isNrlClient ? 'Category' : $isWSL ? 'Your nations' : $isQas ? 'Tracking Category' : 'What sports have you played?' }}</h3>

                    <tags type="sport" v-model="sportTags"/>

                    <ul>
                      <li
                        v-for="tag in sportTags"
                        :key="tag.id"
                        :sync="true"
                        style="list-style-type: none;">
                        <div class="col-xs-8">
                          Are you still playing {{ tag.name }}?
                        </div>
                        <div class="col-xs-4">
                          <toggle-button
                            v-if="tag.pivot && tag.pivot.retired === null"
                            v-model="tag.pivot.retired"
                            :sync="true"
                            :color="{ checked: '#565656', unchecked: '#565656' }"
                            :labels="{ checked: 'UNSET', unchecked: 'UNSET' }"
                            :width="60"/>
                          <toggle-button
                            v-if="tag.pivot && tag.pivot.retired !== null"
                            v-model="tag.pivot.retired"
                            :sync="true"
                            :color="{ checked: '#b7b7b7', unchecked: $brandPrimary }"
                            :labels="{ checked: 'NO', unchecked: 'YES' }"/>
                        </div>
                      </li>
                    </ul>

                    <div class="decorative-divider"></div>

                    <h3>Your {{ $t('Leagues') }}</h3>

                    <tags type="league" v-model="leagueTags"/>

                    <ul>
                      <li
                        v-for="tag in leagueTags"
                        :key="tag.id"
                        :sync="true"
                        style="list-style-type: none;">
                        <div class="col-xs-8">
                          Are you still playing for {{ tag.name }}?
                        </div>
                        <div class="col-xs-4">
                          <toggle-button
                            v-if="tag.pivot && tag.pivot.retired === null"
                            v-model="tag.pivot.retired"
                            :sync="true"
                            :color="{ checked: '#565656', unchecked: '#565656' }"
                            :labels="{ checked: 'UNSET', unchecked: 'UNSET' }"
                            :width="60"/>
                          <toggle-button
                            v-if="tag.pivot && tag.pivot.retired !== null"
                            v-model="tag.pivot.retired"
                            :sync="true"
                            :color="{ checked: '#b7b7b7', unchecked: $brandPrimary }"
                            :labels="{ checked: 'NO', unchecked: 'YES' }"/>
                        </div>
                      </li>
                    </ul>
                  </div>

                  <template v-if="$highSchoolTags">
                    <h3>High School Attended</h3>

                    <tags type="highSchool" v-model="highSchoolTags"/>
                  </template>

                  <template v-if="$collegeTags">
                    <div class="decorative-divider"></div>

                    <h3>College Attended</h3>

                    <tags type="college" v-model="collegeTags"/>
                  </template>

                  <template v-if="$degreeCompletedTags">
                    <div class="decorative-divider"></div>

                    <h3>Degree Completed</h3>

                    <tags type="degreeCompleted" v-model="degreeCompletedTags" :multiple=false :allowCreate=false />
                  </template>

                  <template v-if="$firstContractTags">
                    <div class="decorative-divider"></div>

                    <h3>Year Of First Contract</h3>

                    <tags type="firstContract" v-model="firstContractTags"  :multiple=false :allowCreate=false />
                  </template>

                  <div class="decorative-divider"></div>

                  <h3>{{ $t('Your club and/or event') }}</h3>

                  <tags type="club" v-model="clubTags"/>

                  <ul>
                    <li
                      v-for="tag in clubTags"
                      :key="tag.id"
                      :sync="true"
                      style="list-style-type: none;">
                      <div class="col-xs-8">
                        Are you still playing for {{ tag.name }}?
                      </div>
                      <div class="col-xs-4">
                        <toggle-button
                          v-if="tag.pivot && tag.pivot.retired === null"
                          v-model="tag.pivot.retired"
                          :sync="true"
                          :color="{ checked: '#565656', unchecked: '#565656' }"
                          :labels="{ checked: 'UNSET', unchecked: 'UNSET' }"
                          :width="60"/>
                        <toggle-button
                          v-if="tag.pivot && tag.pivot.retired !== null"
                          v-model="tag.pivot.retired"
                          :sync="true"
                          :color="{ checked: '#b7b7b7', unchecked: $brandPrimary }"
                          :labels="{ checked: 'NO', unchecked: 'YES' }"/>
                      </div>
                    </li>
                  </ul>

                  <template v-if="$positionTags">
                    <div class="decorative-divider"></div>

                    <h3>{{ $t('Your position') }}</h3>

                    <tags type="position" v-model="positionTags"/>
                  </template>

                  <template v-if="$awardTags">
                    <div class="decorative-divider"></div>

                    <h3>{{ $t('Your awards') }}</h3>

                    <tags type="award" v-model="awardTags"/>
                  </template>

                  <template v-if="$proBowlTags">
                    <div class="decorative-divider"></div>

                    <h3>Have you ever made it to a Pro Bowl?</h3>

                    <tags type="proBowl" v-model="proBowlTags" :multiple=false :allowCreate=false />
                  </template>
              </div>
            </div>
            <ladda-button
              type="submit"
              class="btn btn-primary"
              :click="handleSaveTagsCallback">
              Save Changes
            </ladda-button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Tags from 'components/misc/Tags'
import { notify } from 'utils'
import { helpers } from 'mixins/profile'
import { OpportunityTracker } from 'mixins/analytics'

export default {
  mixins: [helpers, OpportunityTracker],

  components: {
    Tags
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapState('talent/tag', ['tags']),

    sportTags: {
      get () {
        return this.tags.sport
      },

      set (tags) {
        this.replaceTags({ type: 'sport', tags })
      }
    },

    clubTags: {
      get () {
        return this.tags.club
      },

      set (tags) {
        this.replaceTags({ type: 'club', tags })
      }
    },

    leagueTags: {
      get () {
        return this.tags.league
      },

      set (tags) {
        this.replaceTags({ type: 'league', tags })
      }
    },

    positionTags: {
      get () {
        return this.tags.position
      },

      set (tags) {
        this.replaceTags({ type: 'position', tags })
      }
    },

    awardTags: {
      get () {
        return this.tags.award
      },

      set (tags) {
        this.replaceTags({ type: 'award', tags })
      }
    },

    highSchoolTags: {
      get () {
        return this.tags.highSchool
      },

      set (tags) {
        this.replaceTags({ type: 'highSchool', tags })
      }
    },

    collegeTags: {
      get () {
        return this.tags.college
      },

      set (tags) {
        this.replaceTags({ type: 'college', tags })
      }
    },

    degreeCompletedTags: {
      get () {
        return this.tags.degreeCompleted
      },

      set (tags) {
        this.replaceTags({ type: 'degreeCompleted', tags })
      }
    },

    proBowlTags: {
      get () {
        return this.tags.proBowl
      },

      set (tags) {
        this.replaceTags({ type: 'proBowl', tags })
      }
    },

    firstContractTags: {
      get () {
        return this.tags.firstContract
      },

      set (tags) {
        this.replaceTags({ type: 'firstContract', tags })
      }
    }
  },

  data () {
    return {
      tagsHaveBeenPreloaded: false
    }
  },

  created () {
    this.loadTags()
  },

  watch: {
    user: 'loadTags'
  },

  methods: {
    ...mapActions('talent/tag', ['getTalentTags', 'updateTalentTags', 'replaceTags']),

    /**
     * Handle saving tags against a user.
     *
     * @return Promise
     */
    handleSaveTagsCallback () {
      return this.updateTalentTags({
        id: this.user.id,
        payload: {
          tags: {
            sport: this.sportTags,
            club: this.clubTags,
            league: this.leagueTags,
            position: this.positionTags,
            award: this.awardTags,
            highSchool: this.highSchoolTags,
            college: this.collegeTags,
            degreeCompleted: this.degreeCompletedTags,
            proBowl: this.proBowlTags,
            firstContract: this.firstContractTags
          }
        }
      }).then(() => {
        notify.success('Successfully saved what you are known for.')
        this.trackEvent(this.analytics.V2.AccountSectionEditEvent, { sectionName: this.analytics.V2.ValidatedAccountSectionName.KNOWN_FOR })
      }).catch((errors) => {
        notify.error('Sorry something has gone wrong, please try again.')
      })
    }
  }
}
</script>
